export const FSBOFAQ = () => {
  const faqs = [
    {
      question: "Is it legal to sell my apartment building for sale by owner?",
      answer: "Yes, it's completely legal to sell your apartment building without a real estate agent. You own the property and have the right to sell it however you choose. Many commercial property owners successfully sell FSBO, especially when working with experienced direct buyers who understand the process."
    },
    {
      question: "How do I determine the right price for my apartment building?",
      answer: "Apartment buildings are valued based on their income potential, not comparable sales like residential homes. The key metric is the capitalization rate (cap rate). We can help you understand your property's value based on current market cap rates, your net operating income, and comparable sales in your area. As direct buyers, we'll provide a fair market offer based on these factors."
    },
    {
      question: "Do I need a lawyer to sell FSBO?",
      answer: "While not legally required in most states, we strongly recommend having a real estate attorney review the purchase agreement and closing documents. This protects your interests and ensures all legal requirements are met. The cost is typically $1,500-$3,000, which is minimal compared to the commission savings."
    },
    {
      question: "How do I handle the title and escrow process?",
      answer: "As the buyer, we typically open escrow with a title company and handle most of the coordination. The title company will conduct a title search, prepare closing documents, and facilitate the transfer of funds and property ownership. You'll need to provide some documents and sign papers at closing, but the title company guides you through everything."
    },
    {
      question: "What if my tenants find out I'm selling?",
      answer: "With a direct sale to us, we can keep the transaction completely confidential until closing. Unlike traditional listings that appear publicly, our private transaction means tenants typically don't learn about the sale until after closing when they receive a notice of ownership change, which is legally required."
    },
    {
      question: "Can I still do a 1031 exchange when selling FSBO?",
      answer: "Absolutely! Selling FSBO doesn't affect your ability to do a 1031 exchange. You'll work with a qualified intermediary just as you would in any sale. We're experienced in facilitating 1031 exchanges and can structure the transaction to meet all IRS requirements for tax deferral."
    },
    {
      question: "What documents do I need to provide?",
      answer: "We'll need: current rent roll, last 12 months of income and expense statements, property tax bills, insurance information, utility bills, any service contracts, and information about capital improvements. If you have them, we'd also like to see leases, tenant applications, and maintenance records. Don't worry if your records aren't perfect—we work with what you have."
    },
    {
      question: "How long does the FSBO process take with a direct buyer?",
      answer: "From initial contact to closing typically takes 3-4 weeks. We can move faster if needed—we've closed deals in as little as 10 days when sellers had urgent timelines. Traditional listings often take 6-12 months, so selling FSBO to a direct buyer is significantly faster."
    },
    {
      question: "What if my property has deferred maintenance or problems?",
      answer: "We buy properties AS IS, which means you don't need to make any repairs or improvements. We factor the property's condition into our offer price. Whether your building needs a new roof, has plumbing issues, or requires unit renovations, we'll still make an offer and close without requiring you to fix anything."
    },
    {
      question: "How do you determine your offer price?",
      answer: "We analyze your property's net operating income (NOI), current market cap rates, property condition, location, and comparable sales. Our offer reflects fair market value for an AS IS purchase with a quick closing. We'll explain our valuation in detail so you understand exactly how we arrived at the offer price."
    },
    {
      question: "Can you help me with seller financing?",
      answer: "Yes, we frequently structure deals with seller financing, which can provide significant tax advantages for you. We can discuss various structures: partial seller financing, full seller financing, or installment sales. This flexibility is one of the key advantages of selling to a direct buyer rather than someone who needs traditional bank financing."
    },
    {
      question: "What happens to my tenants after the sale?",
      answer: "Your tenants' leases transfer to us as the new owner. We honor all existing lease terms, security deposits, and tenant rights. We're experienced landlords who maintain properties well and treat tenants fairly. Most tenants don't even notice the ownership change beyond receiving a notice about where to send rent payments."
    },
    {
      question: "Do I need to disclose problems with the property?",
      answer: "Yes, you're legally required to disclose known material defects. However, as experienced investors buying AS IS, we expect normal wear and tear and typical apartment building issues. We're not going to be surprised by old roofs, outdated systems, or deferred maintenance. Honest disclosure protects you legally and helps us make an accurate offer."
    },
    {
      question: "What if I owe more than the property is worth?",
      answer: "If you're underwater on your mortgage, we may still be able to help through a short sale negotiation with your lender. We have experience working with banks to facilitate short sales. While not every situation works out, it's worth having a conversation to explore your options."
    },
    {
      question: "How is selling FSBO different from listing with an agent?",
      answer: "The main differences: you save 5-6% in commissions, you control the process and timeline, you choose who sees your property, and you negotiate directly with the buyer. The trade-off is you don't have an agent's marketing reach—but when selling to a direct buyer like us, you don't need marketing. You get the benefits of FSBO without the typical challenges."
    }
  ];

  return (
    <section id="fsbo-faq" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4 text-gray-900">
            For Sale by Owner: Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about selling your apartment building FSBO to a direct buyer
          </p>
        </div>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow group"
            >
              <summary className="cursor-pointer p-6 font-semibold text-lg text-gray-900 flex justify-between items-center">
                <span className="pr-8">{faq.question}</span>
                <i className="ri-arrow-down-s-line text-2xl text-teal-600 group-open:rotate-180 transition-transform flex-shrink-0"></i>
              </summary>
              <div className="px-6 pb-6 text-gray-700 leading-relaxed border-t border-gray-100 pt-4">
                {faq.answer}
              </div>
            </details>
          ))}
        </div>

        <div className="mt-12 bg-teal-50 border-l-4 border-teal-500 p-6 rounded-r-lg">
          <h3 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
            <i className="ri-question-line text-teal-600"></i>
            Have More Questions?
          </h3>
          <p className="text-gray-700">
            Every apartment building sale is unique. If you have specific questions about your property or situation, we're happy to discuss them. Contact us for a confidential conversation about your FSBO sale options.
          </p>
        </div>
      </div>
    </section>
  );
};